import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { Suspense, useCallback, useState, useRef, useEffect } from 'react';
import TearsheetModal from './tearsheetModal/tearsheetModal';
import TearsheetPDF from './tearsheetPDF';
import { useReactToPrint } from 'react-to-print';
import { useAppContext } from '@magento/peregrine/lib/context/app';

var Tearsheet = function Tearsheet(_ref) {
  var isOpen = _ref.isOpen,
      productDetails = _ref.productDetails,
      customAttributes = _ref.customAttributes,
      product = _ref.product,
      optionSelections = _ref.optionSelections,
      disabledValuesMap = _ref.disabledValuesMap,
      itemId = _ref.itemId,
      smartString = _ref.smartString,
      weight = _ref.weight,
      showPdfOptions = _ref.showPdfOptions;

  var _useAppContext = useAppContext(),
      _useAppContext2 = _slicedToArray(_useAppContext, 2),
      closeDrawer = _useAppContext2[1].closeDrawer;

  var handlePrint = useReactToPrint({
    content: function content() {
      return pdfComponent.current;
    }
  });

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      pdfData = _useState2[0],
      setPdfData = _useState2[1];

  var pdfComponent = useRef();
  var generateDownloadLinkAndOpen = useCallback(function () {
    handlePrint();
  }, [handlePrint]);
  var onSubmitFn = useCallback(function (values) {
    setPdfData(_objectSpread({}, values));
    setTimeout(function () {
      generateDownloadLinkAndOpen();
      closeDrawer();
    }, 500);
  }, [setPdfData, generateDownloadLinkAndOpen]);
  useEffect(function () {
    if (isOpen && !showPdfOptions) {
      onSubmitFn({
        note: '',
        price: 'Hide pricing'
      });
      closeDrawer();
    }
  }, [showPdfOptions, isOpen]);
  return React.createElement(React.Fragment, null, isOpen && showPdfOptions && React.createElement(TearsheetModal, {
    isOpen: isOpen,
    productDetails: productDetails,
    customAttributes: customAttributes,
    product: product,
    optionSelections: optionSelections,
    itemId: itemId,
    smartString: smartString,
    weight: weight,
    generateDownloadLinkAndOpen: generateDownloadLinkAndOpen,
    onSubmitFn: onSubmitFn
  }), React.createElement("div", {
    className: "hidden"
  }, React.createElement(Suspense, {
    fallback: React.createElement(React.Fragment, null)
  }, React.createElement(TearsheetPDF, {
    ref: pdfComponent,
    pdfOptions: pdfData,
    customAttributes: customAttributes,
    disabledValuesMap: disabledValuesMap,
    productDetails: productDetails,
    product: product,
    optionSelections: optionSelections,
    itemId: itemId,
    smartString: smartString,
    weight: weight,
    pdfData: pdfData
  }))));
};

export default Tearsheet;